
export default function Logout() {
  return (
    <div>
      
    </div>
  )
}
